import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSiteSettings, saveSiteSettings } from '../../redux/slices/settingsSlice';
import { toast } from 'react-toastify';
import './BrandSettings.css';

const BrandSettings = () => {
  const dispatch = useDispatch();
  const { siteSettings, loading } = useSelector((state) => state.settings);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    dispatch(fetchSiteSettings());
  }, [dispatch]);

  useEffect(() => {
    if (siteSettings) {
      setFormData({
        site_name: siteSettings.site_name || '',
        primary_color: siteSettings.primary_color || '#d7192a',
        primary_dark: siteSettings.primary_dark || '#b51220',
        accent_color: siteSettings.accent_color || '#ff6b6b',
        logo: null,
        remove_logo: false,
      });
    }
  }, [siteSettings]);

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append('site_name', formData.site_name);
    form.append('primary_color', formData.primary_color);
    form.append('primary_dark', formData.primary_dark);
    form.append('accent_color', formData.accent_color);
    if (formData.logo) form.append('logo', formData.logo);
    if (formData.remove_logo) form.append('remove_logo', '1');

    dispatch(saveSiteSettings(form)).unwrap().then(() => {
      toast.success('Identidad visual actualizada con éxito');
    }).catch((err) => {
      toast.error(err || 'Error al guardar la configuración');
    });
  };

  if (!formData) return <div>Cargando...</div>;

  return (
    <div className="brand-settings-container">
      <div className="settings-header">
        <h1>Identidad visual</h1>
        <p>Personaliza la marca sin editar código.</p>
      </div>

      <div className="settings-card">
        <div className="card-header">
          <h2>Logo y paleta corporativa</h2>
          <p>Los cambios se aplican en escritorio y móvil.</p>
        </div>

        <form onSubmit={handleSubmit} className="brand-form" encType="multipart/form-data">
          <div className="form-group full">
            <label htmlFor="site_name">Nombre de la plataforma</label>
            <input
              id="site_name"
              type="text"
              name="site_name"
              value={formData.site_name}
              onChange={handleInputChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="primary_color">Color principal</label>
            <div className="color-input-wrapper">
              <input
                id="primary_color"
                type="color"
                name="primary_color"
                value={formData.primary_color}
                onChange={handleInputChange}
                disabled={loading}
              />
              <span className="color-value">{formData.primary_color}</span>
            </div>
            <small>Botones, enlaces y acciones</small>
          </div>

          <div className="form-group">
            <label htmlFor="primary_dark">Rojo oscuro</label>
            <div className="color-input-wrapper">
              <input
                id="primary_dark"
                type="color"
                name="primary_dark"
                value={formData.primary_dark}
                onChange={handleInputChange}
                disabled={loading}
              />
              <span className="color-value">{formData.primary_dark}</span>
            </div>
            <small>Fondos y estados activos</small>
          </div>

          <div className="form-group">
            <label htmlFor="accent_color">Color de apoyo</label>
            <div className="color-input-wrapper">
              <input
                id="accent_color"
                type="color"
                name="accent_color"
                value={formData.accent_color}
                onChange={handleInputChange}
                disabled={loading}
              />
              <span className="color-value">{formData.accent_color}</span>
            </div>
            <small>Tarjetas y elementos secundarios</small>
          </div>

          <div className="form-group logo-upload">
            <label htmlFor="logo">Nuevo logo</label>
            <input
              id="logo"
              type="file"
              name="logo"
              accept="image/png,image/jpeg,image/webp"
              onChange={handleInputChange}
              disabled={loading}
            />
            <small>PNG, JPG o WebP · máximo 2 MB</small>
          </div>

          {siteSettings?.logo_path && (
            <label className="checkbox">
              <input
                type="checkbox"
                name="remove_logo"
                checked={formData.remove_logo}
                onChange={handleInputChange}
                disabled={loading}
              />
              Recuperar el casco SVG original
            </label>
          )}

          <button type="submit" disabled={loading} className="btn btn-primary btn-block">
            {loading ? 'Guardando...' : 'Guardar identidad visual'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BrandSettings;
